import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

// iter147 — Beta feedback: toggle was hard to read (color-only). Now shows
// explicit "ON"/"OFF" text baked into the track so state is obvious at a glance.
const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer relative inline-flex h-6 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-emerald-600 data-[state=checked]:border-emerald-700 data-[state=unchecked]:bg-slate-300 data-[state=unchecked]:border-slate-400 dark:data-[state=unchecked]:bg-slate-600 dark:data-[state=unchecked]:border-slate-700",
      className
    )}
    {...props}
    ref={ref}>
    {/* Static ON/OFF labels behind the thumb — visible on either side. */}
    <span
      aria-hidden
      className="pointer-events-none absolute left-1.5 top-1/2 -translate-y-1/2 text-[9px] font-bold leading-none tracking-wider text-white opacity-0 transition-opacity data-[state=checked]:opacity-100 peer-data-[state=checked]:opacity-100"
      data-state="checked"
    >ON</span>
    <span
      aria-hidden
      className="pointer-events-none absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] font-bold leading-none tracking-wider text-slate-700 dark:text-slate-100 opacity-0 transition-opacity data-[state=unchecked]:opacity-100 peer-data-[state=unchecked]:opacity-100"
      data-state="unchecked"
    >OFF</span>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none relative z-10 block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-8 data-[state=unchecked]:translate-x-0.5"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
